// extracted by mini-css-extract-plugin
var _1 = "ChatTableRowLastMessage-modulecolon__yowM5";
var _2 = "ChatTableRowLastMessage-modulecontainer__DpaAP";
var _3 = "ChatTableRowLastMessage-moduleicon__MhoTd";
var _4 = "ChatTableRowLastMessage-modulelastMessage__zK5fB";
var _5 = "ChatTableRowLastMessage-modulelastMessageContainer__njSHk";
var _6 = "ChatTableRowLastMessage-modulelastMessageCounter__xfyXy";
var _7 = "ChatTableRowLastMessage-modulelastMessageUser__B9QqM";
var _8 = "ChatTableRowLastMessage-modulenameWrapper__o2_Te";
var _9 = "ChatTableRowLastMessage-moduletext__gUlhf";
var _a = "ChatTableRowLastMessage-moduletextContainer___VomZ";
var _b = "ChatTableRowLastMessage-moduleunread__YQLaW Text-moduleunread__s_OU0";
var _c = "ChatTableRowLastMessage-moduleuserName__iW6Yh";
export { _1 as "colon", _2 as "container", _3 as "icon", _4 as "lastMessage", _5 as "lastMessageContainer", _6 as "lastMessageCounter", _7 as "lastMessageUser", _8 as "nameWrapper", _9 as "text", _a as "textContainer", _b as "unread", _c as "userName" }
